import { actionTypes } from "./storeTypes";

export const init_local = {
  breakageandreturn: { rawdata: [] },
  breakageandreturnFiltered: [],
  filter: {
    Ticker: [],
    ModelDate: [],
    Horizon: [],
    RiskModel:[],
    " Pctile ":[]
  },
  filterDefaults: {
    Ticker: [],
    ModelDate: [],
    Horizon: [],
    RiskModel:[],
    " Pctile ":[]
  },
  loading: true,
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_BREAKAGEANDRETURN: {
      return {
        ...state,
        breakageandreturn: action.payload,
      };
    }
    case actionTypes.SET_BREAKAGEANDRETURN_FILTERED: {
      return {
        ...state,
        breakageandreturnFiltered: action.payload,
      };
    }
    case actionTypes.SET_FILTER: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case actionTypes.SET_FILTER_DEFAULTS: {
      return {
        ...state,
        filterDefaults: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
